module.exports = __webpack_public_path__ + "media/theme/top_accordion_PC_4 open-b283eb64.png";